import { FormItemCol } from "../FormItemCol";
import { PlaybookCardSection } from "../PlaybookCardSection";
import { Col } from "antd";
import { useTranslate } from "#src/hooks";

export const MainSection = () => {
  const t = useTranslate();
  return (
    <>
      <Col xs={24}>
        <PlaybookCardSection
          title={t("pages.playbooks.sections.main.mainInfo")}
        />
      </Col>
      <FormItemCol
        name="name"
        label={t("pages.playbooks.sections.main.playbookName")}
        component="input"
        placeholder={t(
          "pages.playbooks.sections.main.playbookNamePlaceholderEdit"
        )}
      />
      <FormItemCol
        name="description"
        label={t("pages.playbooks.sections.main.playbookDescription")}
        component="textarea"
        placeholder={t(
          "pages.playbooks.sections.main.playbookDescriptionPlaceholder"
        )}
        rows={2}
      />
    </>
  );
};
